<ng-content /> <!-- Without this the label is rendered twice during ssr -->
<ng-container *ngTemplateOutlet="label" />
